module.exports = __webpack_public_path__ + "img/tm4.d0c1825f.png";